import config from "@/config";
import Vue from "vue";

const base = config.api_base + "/card/plugin/middle-man";


export default {
    rule: (params) => Vue.axios.post(base + "/rule", params),
    ruleEdit: (params) => Vue.axios.post(base + "/rule-edit", params),
}